module.exports = __webpack_public_path__ + "static/img/13-02.f928e94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/13-02.png
// module id = 4M+W
// module chunks = 0